<template>
    <!-- <b-overlay :show="busy" rounded="sm"> -->

    <b-card class="standardpage reports invoices border-none">
        <div class="availtable datatable">
            <b-card class="w-100pct">

                <b-card-body class="py-0 px-0">

                    <b-tabs class="gridtabs" v-model="tabindex">

                        <b-tab>
                            <template #title>
                                <div class="badgecontainer pr-2 mr-1">
                                    <i class="fa fa-share text-info mr-1"></i>
                                    Assign
                                    <b-badge v-if="selection.length > 0" id="selection" variant="primary" class="edit_tab">
                                        {{ selection.length }}</b-badge>
                                    <b-tooltip v-if="selection.length > 0" target="selection" placement="bottom">{{
                                        selection.length }} ticket(s)
                                        selected</b-tooltip>
                                </div>

                            </template>

                            <p class="mt-2">

                                <b-row class="my-2">
                                    <b-col cols="12" sm="6" md="4">
                                        <b-form-group label-cols="12" label="Date" label-size="sm">


                                            <b-input-group>
                                                <daterangepicker style="width:auto !important" size="sm" ref="date_at"
                                                    v-model="date_at" :opens="'right'" :locale-data="locale_data"
                                                    :ranges="false" :showDropdowns="true" :linkedCalendars="true" :single-date-picker="'true'">
                                                </daterangepicker>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="date_at = {
                                                        startDate: null,
                                                        endDate: null,
                                                    }
                                                        ">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                </b-row>


                                <b-row>
                                    <b-col cols="12">
                                        <b-form-group label="Subject" label-for="Subject" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.subject" placeholder="Subject"
                                                    size="sm" :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" :disabled="true" variant="outline-secondary"
                                                        @click="item.subject = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12">
                                        <b-form-group label="Details" label-for="details" label-cols="12">
                                            <b-form-textarea :disabled="true" id="details" v-model="item.details"
                                                placeholder="Details" rows="12" class="smalltextarea"></b-form-textarea>
                                        </b-form-group>
                                    </b-col>
                                </b-row>

                                <b-row class="mt-2">
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Supplier BL A/C" label-size="sm">
                                            <treeselect placeholder="Select blac..."
                                                searchPromptText="Type at least 3 chars..." v-model="item.blac"
                                                :clearable="true" :async="true" :load-options="treeselect_loadBLAC"
                                                :show-count="true" :flatten-search-results="true"
                                                :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                :disabled="true">
                                                <div slot="value-label" slot-scope="{ node }">
                                                    {{ node.raw.id }}
                                                </div>
                                            </treeselect>
                                        </b-form-group>
                                    </b-col>


                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="BL Total" label-for="bltotal" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.bltotal" placeholder="SL Total"
                                                    size="sm" :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" :disabled="true" variant="outline-secondary"
                                                        @click="item.bltotal = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="BL Invoice No" label-for="blinvoiceno" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.blinvoiceno"
                                                    placeholder="BL Invoice No" size="sm" :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" :disabled="true" variant="outline-secondary"
                                                        @click="item.blinvoiceno = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="SL Total" label-for="sltotal" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.sltotal" placeholder="SL Total"
                                                    size="sm" :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" :disabled="true" variant="outline-secondary"
                                                        @click="item.sltotal = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </p>

                        </b-tab>

                        <b-tab>
                            <template #title>
                                <i class="fa fa-check-square-o text-primary mr-1"></i>
                                Sales</template>
                            <p class="pt-3 px-0">

                                <b-row class="mt-3 mb-3 mx-n3">
                                    <b-col cols="auto" class="mr-auto"> <b-list-group horizontal="md" size="sm">
                                            <b-list-group-item variant="dark"><span class="list-label">To:
                                                    {{ item.slac }}</span> {{ item.to }}</b-list-group-item>
                                            <b-list-group-item variant="dark"><span class="list-label">Your
                                                    Ref/PO:</span>{{ item.yourref }}</b-list-group-item>
                                            <b-list-group-item variant="dark"><span class="list-label">Event:</span>{{
                                                item.eventcode }}</b-list-group-item>
                                            <b-list-group-item variant="dark"><span class="list-label">Date:</span>{{
                                                $moment().format("DD/MM/YYYY")
                                            }}</b-list-group-item>
                                        </b-list-group></b-col>

                                    <b-col cols="auto" v-if="selection.length == 1">

                                        <b-list-group horizontal="md" size="sm">
                                            <b-list-group-item variant="dark-primary"><span class="list-label">Total
                                                    GBP:</span>{{ saletotal | currency("")
                                                    }}</b-list-group-item>
                                        </b-list-group></b-col>


                                    <b-col cols="auto" v-if="selection.length > 1"> <b-list-group horizontal="md" size="sm">
                                            <b-list-group-item variant="dark-danger"><span
                                                    class="list-label">Invoices:</span><span class="strong h6">{{
                                                        selection.length
                                                    }}</span></b-list-group-item>
                                        </b-list-group></b-col>

                                    <div>

                                    </div>
                                </b-row>

                                <b-tabs>
                                    <b-tab>
                                        <template #title>
                                            <div class="badgecontainer pr-1 mr-1 w-60px">
                                                <i class="fa fa-list ml-1 text-info"></i> Lines
                                                <b-badge variant="white" class="edit_tab">
                                                </b-badge>

                                            </div>
                                        </template>

                                        <b-row>
                                            <b-col>
                                                <d-table classdivtable="availtable datatable nested" refid="sllines"
                                                    :icon="sllines.icon" :busy="sllines.busy" :tools="sllines.tools"
                                                    :badges="sllines.badges" :toolbarlibrary="sllines.toolbarlibrary"
                                                    :fields="sllines.fields" :items="sllines.items" :page="sllines.page"
                                                    :limit="100" :showpages="false" @load="sllines_load"
                                                    @click="sllines_click" @select="sllines_select" :tableheight="230">
                                                </d-table>
                                            </b-col>
                                        </b-row>
                                        <!-- <b-row class="mt-2"><b-col>
                                                    Select a line item above to change any of the details. To include a
                                                    template item change the quantity to include it on the invoice.
                                                </b-col>

                                            </b-row> -->
                                        <div v-if="edit && sllines.item.passenger">
                                            <b-row>
                                                <b-col cols="12" class="text-right">
                                                    <b-button size="sm" variant="outline-primary" @click="edit = false">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-col>
                                            </b-row>
                                            <b-row class="mt-3">
                                                <b-col cols="12" sm="6" md="3" xl="3">
                                                    <b-form-group label="TicketNo" label-for="ConfirmNo" label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="sllines.item.ticketno"
                                                                placeholder="TicketNo" size="sm"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="sllines.item.ticketno = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="6" md="3" xl="3">
                                                    <b-form-group label="Passenger" label-for="Passenger" label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="sllines.item.passenger"
                                                                placeholder="Passenger" size="sm"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="sllines.item.passenger = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="6" md="3" xl="3">
                                                    <b-form-group label="Route/Detail" label-for="route" label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="sllines.item.route"
                                                                placeholder="Route/Detail" size="sm"
                                                                :disabled="readonly"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" :disabled="readonly"
                                                                    variant="outline-secondary"
                                                                    @click="sllines.item.route = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label-cols="12" label="DateTravel" label-size="sm">
                                                        <b-input-group>
                                                            <v-date-picker v-model="datetravel" mode="date" is24hr
                                                                color="green" :locale="'en-gb'"
                                                                class="form-control form-control-sm" :disabled="readonly">
                                                                <template v-slot="{ inputValue, inputEvents }">
                                                                    <input :disabled="true" placeholder="DateTravel" class="text-primary h-19px border-none
                                                                    focus:outline-none focus:border-primary
                                                                    " :value="inputValue" v-on="inputEvents" />
                                                                </template>
                                                            </v-date-picker>
                                                            <b-input-group-append>
                                                                <b-button size="sm" squared variant="outline-secondary"
                                                                    :disabled="true" @click="datetravel = null">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="9">
                                                    <b-form-group label="More Info" label-for="moreinfo" label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="sllines.item.moreinfo"
                                                                placeholder="More Info" size="sm"
                                                                :disabled="readonly"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" :disabled="readonly"
                                                                    variant="outline-secondary"
                                                                    @click="sllines.item.moreinfo = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label="Remark" label-for="remark" label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="sllines.item.remark"
                                                                placeholder="Remark" size="sm" trim
                                                                :disabled="readonly"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="sllines.item.remark = ''" :disabled="readonly">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="6" md="3" xl="3">
                                                    <b-form-group label="Qty" label-for="qty" label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="number" v-model="sllines.item.qty"
                                                                placeholder="Qty" size="sm" :disabled="true"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label="Unit Price Ex VAT" label-for="lineprice"
                                                        label-cols="12" label-size="sm" class="mb-0">
                                                        <b-input-group class="treeselect_all justify-content-end pr-37px">
                                                            <span style="padding-top: 0.3em">Markup GBP</span>

                                                        </b-input-group>
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="sllines.item.lineprice"
                                                                placeholder="Unit Price Ex VAT" size="sm" trim
                                                                :disabled="readonly"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="sllines.item.lineprice = sllines.item.blfare; markup_lineprice = '0.00'; markup_linesubtotal = sllines.item.bltotal"
                                                                    :disabled="readonly">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                            <b-form-input class="text-right" type="text"
                                                                :state="parseFloat(markup_lineprice) < 0 ? false : null"
                                                                v-model="markup_lineprice" :debounce="sllines.debounce"
                                                                size="sm" :disabled="false"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="sllines_markup('lineprice')"
                                                                    :disabled="readonly">
                                                                    <i class="fa fa-line-chart text-primary"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label="Unit Taxes" label-for="linetaxes" label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="sllines.item.linetaxes"
                                                                placeholder="Unit Taxes" size="sm" trim
                                                                :disabled="true"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="sllines.item.linetaxes = '0.00'"
                                                                    :disabled="true">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label="Unit Subtotal Ex VAT" label-for="linesubtotal"
                                                        label-cols="12" label-size="sm" class="mb-0">
                                                        <b-input-group class="treeselect_all justify-content-end pr-37px">
                                                            <span style="padding-top: 0.3em">Markup Total GBP</span>
                                                        </b-input-group>

                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="sllines.item.linesubtotal"
                                                                placeholder="Unit Subtotal Ex VAT" size="sm" trim
                                                                :disabled="true"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="sllines.item.linesubtotal = sllines.item.bltotal; markup_lineprice = '0.00'; markup_linesubtotal = sllines.item.bltotal"
                                                                    :disabled="readonly">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                            <b-form-input class="text-right" type="text"
                                                                :state="parseFloat(markup_linesubtotal) < 0 ? false : null"
                                                                v-model="markup_linesubtotal" :debounce="sllines.debounce"
                                                                size="sm" :disabled="false"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="sllines_markup('linesubtotal')"
                                                                    :disabled="readonly">
                                                                    <i class="fa fa-line-chart text-primary"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label="Unit Fees" label-for="linefees" label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="sllines.item.linefees"
                                                                placeholder="Unit Fees" size="sm" trim
                                                                :disabled="readonly"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="sllines.item.linefees = '0.00'"
                                                                    :disabled="readonly">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label="Unit VAT" label-for="linevat" label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="sllines.item.linevat"
                                                                placeholder="Unit VAT" size="sm" trim
                                                                :disabled="readonly"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="sllines.item.linevat = '0.00'"
                                                                    :disabled="readonly">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label="Unit Total" label-for="linetotal" label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="text" :debounce="500"
                                                                v-model="sllines.item.linetotal" placeholder="Unit Total"
                                                                size="sm" trim :disabled="true"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="sllines.item.linetotal = ''" :disabled="true">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label-cols="12" label="Supplier BL A/C" label-size="sm">
                                                        <treeselect placeholder="Select blac..."
                                                            searchPromptText="Type at least 3 chars..."
                                                            v-model="sllines.item.blac" :clearable="true" :async="true"
                                                            :load-options="treeselect_loadBLAC" :show-count="true"
                                                            :flatten-search-results="true" :disable-branch-nodes="true"
                                                            :matchKeys="['id']" search-nested :disabled="readonly">
                                                            <div slot="value-label" slot-scope="{ node }">
                                                                {{ node.raw.id }}
                                                            </div>
                                                        </treeselect>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label="BL Fare" label-for="fare" label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="sllines.item.blfare"
                                                                placeholder="Fare" size="sm" trim
                                                                :disabled="true"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="sllines.item.blfare = '0.00'" :disabled="true">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label="BL Tax" label-for="tax" label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="sllines.item.bltax"
                                                                placeholder="Tax" size="sm" trim
                                                                :disabled="true"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="sllines.item.bltax = '0.00'" :disabled="true">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label="BL Total" label-for="total" label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="sllines.item.bltotal"
                                                                placeholder="Tax" size="sm" trim
                                                                :disabled="true"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="sllines.item.bltotal = '0.00'" :disabled="true">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label="BL InvoiceNo" label-for="blinvoiceno"
                                                        label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="sllines.item.blinvoiceno"
                                                                placeholder="BL InvoiceNo" size="sm"
                                                                :disabled="false"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" :disabled="false"
                                                                    variant="outline-secondary"
                                                                    @click="sllines.item.blinvoiceno = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>

                                            </b-row>
                                            <!-- 
                                        <b-row>

                                           

                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                <b-form-group label="BL Cost Total GBP" label-for="bltotal" label-cols="12">
                                                    <b-input-group>
                                                        <b-form-input type="text" v-model="item.bltotal"
                                                            :debounce="sllines.debounce" placeholder="BL Cost Total GBP"
                                                            size="sm" :disabled="false"></b-form-input>
                                                        <b-input-group-append>
                                                            <b-button size="sm" :disabled="false"
                                                                variant="outline-secondary" @click="item.bltotal = ''">
                                                                <i class="fa fa-remove"></i>
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>

                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                <b-form-group label="SL InvoiceNo" label-for="invoiceno" label-cols="12">
                                                    <b-input-group>
                                                        <b-form-input type="text" v-model="item.invoiceno"
                                                            placeholder="InvoiceNo" size="sm"
                                                            :disabled="true"></b-form-input>
                                                        <b-input-group-append>
                                                            <b-button size="sm" :disabled="true" variant="outline-secondary"
                                                                @click="item.invoiceno = ''">
                                                                <i class="fa fa-remove"></i>
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>

                                        </b-row>  -->
                                        </div>
                                        <div v-if="!edit">
                                            <b-row align-h="end" class="mt-2 ">
                                                <b-col cols="12" sm="6" md="3" xl="3">
                                                    <b-form-group class="text-right" label="Selection Unit Markup GBP"
                                                        label-for="markup_lineprice" label-cols="12">
                                                        <b-input-group>
                                                            <b-input-group-prepend>
                                                                <b-button size="sm" variant="outline-primary"
                                                                    title="Apply markup"
                                                                    @click="sllines_click('markup_lineprice', sllines.selected)">
                                                                    <i class="fa fa-line-chart"></i>
                                                                </b-button>
                                                            </b-input-group-prepend>
                                                            <b-form-input type="text" v-model="markup_lineprice"
                                                                placeholder="Markup GBP" size="sm"
                                                                class="text-right"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="markup_lineprice = '0.00'">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="6" md="3" xl="3">
                                                    <b-form-group class="text-right" label="Selection Unit Markup Total GBP"
                                                        label-for="markup_linesubtotal" label-cols="12">
                                                        <b-input-group>
                                                            <b-input-group-prepend>
                                                                <b-button size="sm" variant="outline-primary"
                                                                    title="Apply markup"
                                                                    @click="sllines_click('markup_linesubtotal', sllines.selected)">
                                                                    <i class="fa fa-line-chart"></i>
                                                                </b-button>
                                                            </b-input-group-prepend>
                                                            <b-form-input type="text" v-model="markup_linesubtotal"
                                                                placeholder="Markup Total GBP" size="sm"
                                                                class="text-right"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="markup_linesubtotal = '0.00'">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row align-h="end" class="mt-2 ">
                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label="Optional Draft Display (First Segment)"
                                                        label-for="proforma_options" label-cols="12">
                                                        <treeselect v-model="proforma_options" :clearable="true"
                                                            :multiple="true" :options="options_proforma_options"
                                                            placeholder="None...">
                                                        </treeselect>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="6" md="3" xl="3">

                                                    <b-form-group class="text-right" label="Markup Sale Total GBP"
                                                        label-for="markup_saletotal" label-cols="12">
                                                        <b-input-group>
                                                            <b-input-group-prepend>
                                                                <b-button size="sm" variant="outline-primary"
                                                                    title="Apply markup"
                                                                    @click="sllines_click('markup_saletotal', sllines.selected)">
                                                                    <i class="fa fa-line-chart"></i>
                                                                </b-button>
                                                            </b-input-group-prepend>
                                                            <b-form-input type="text" v-model="markup_saletotal"
                                                                placeholder="Markup GBP" size="sm"
                                                                class="text-right"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="markup_saletotal = costtotal.toFixed(2)">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </div>

                                    </b-tab>
                                </b-tabs>

                            </p>
                        </b-tab>

                        <b-tab v-if="selection.length == 1">
                            <template #title>
                                <i class="fa fa-wpforms text-info mr-1"></i>Draft
                            </template>
                            <div class="etr">
                                <b-row>
                                    <b-col cols="12">
                                        <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">

                                            <r-invoice :showasdraft="true" :item="draft" />

                                            <b-alert v-if="draft.message" show :variant="draft.level"
                                                class="text-center mt-2 mb-1">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-info-circle fa-2x"></i></b-col>
                                                    <b-col> <span
                                                            v-html="draft.message ? draft.message.split('\n').join('<br/>') : ''"></span></b-col></b-row>
                                            </b-alert>

                                        </b-overlay>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-tab>

                        <b-tab v-if="selection.length == 1 && item.invoiceno">
                            <template #title>
                                <i class="fa fa-wpforms text-info mr-1"></i>Invoice
                            </template>
                            <div class="etr">
                                <b-row>
                                    <b-col cols="12">
                                        <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
                                            <r-invoice :showasdraft="false" :invoiceno="item.invoiceno" />
                                        </b-overlay>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-tab>
                    </b-tabs>

                </b-card-body>
                <b-card-footer class="nopadding mt-2">
                    <b-row no-gutters>
                        <b-col v-if="tabindex == 1 && user.permissions.includes('bookings.save')" cols="auto"
                            class="text-left">
                            <b-button squared size="sm" variant="primary" @click="sllines_saveit()">
                                <i class="fa fa-check"></i>
                                Save It
                            </b-button>
                        </b-col>
                        <b-col v-if="tabindex == 2 && user.permissions.includes('bookings.invoice')" cols="auto"
                            class="text-left">
                            <!-- :disabled="item.invoiceno" -->
                            <b-button squared size="sm" variant="primary" @click="sllines_postit()" class="mr-1">
                                <i class="fa fa-paper-plane"></i>
                                <span class="ml-1" v-html="item.invoiceno ? 'Re-Invoice It' : 'Invoice It'"></span>
                            </b-button>
                            <b-button squared size="sm" class="ml-1" variant="warning" @click="showledgers = !showledgers"
                                :pressed="!showledgers">
                                Ledgers<i :class="showledgers ? 'fa fa-arrow-up ml-1' : 'fa fa-arrow-down ml-1'
                                    "></i>
                            </b-button>
                        </b-col>
                        <b-col class="text-left ml-2 mt-1">
                            <div v-if="busy">
                                <i class="fa fa-spinner fa-spin text-primary"></i>
                            </div>
                            <div v-else>
                                <span v-html="message"></span>
                            </div>
                        </b-col>

                        <b-col class="text-right" cols="8">
                            <b-button squared size="sm" class="mr-0" variant="secondary" @click="discard">
                                <i class="fa fa-chevron-left"></i>Back
                            </b-button>
                        </b-col>


                    </b-row>
                </b-card-footer>

                <div v-if="showledgers" class="mx-4">
                    <b-row>
                        <b-card class="border-none w-100pct">
                            <b-card-title class="text-left">B/L Item Headers</b-card-title>
                            <d-table classdivtable="availtable datatable" refid="blitemheaders" :items="data.BL"
                                :showpages="false" :showtoolbar="false">
                            </d-table>
                        </b-card>
                    </b-row>
                    <b-row>
                        <b-card class="border-none w-100pct">
                            <b-card-title class="text-left">S/L Item Headers</b-card-title>
                            <d-table classdivtable="availtable datatable" refid="blitemheaders" :items="SL"
                                :showpages="false" :showtoolbar="false">
                            </d-table> </b-card></b-row>
                    <b-row>
                        <b-card class="border-none w-100pct">
                            <b-card-title class="text-left">l Item Lines</b-card-title>
                            <d-table classdivtable="availtable datatable" refid="blitemheaders" :items="data.SL[0].items"
                                :showpages="false" :showtoolbar="false">
                            </d-table> </b-card></b-row>
                </div>
            </b-card>
        </div>

    </b-card>
    <!-- </b-overlay> -->
</template>
  
<script>
import gql from "graphql-tag";

function moveItem(data, from, to) {
    // remove `from` item and store it
    var f = data.splice(from, 1)[0];
    // insert stored item into position `to`
    data.splice(to, 0, f);
}

export default {
    name: "BookingsAssign",
    async mounted() {
        // await this.accessdenied();
    },
    data() {
        return {
            busy: false,
            tabindex: 1,
            debounce: 500,
            message: null,
            textsize: "",
            confirmno: [],
            edit: false,
            markup_lineprice: "0.00",
            markup_linesubtotal: "0.00",
            markup_saletotal: "0.00",
            date_at: {
                startDate: this.$moment().format("YYYY-MM-DD"),
                endDate: this.$moment().format("YYYY-MM-DD"),
            },
            datetravel: null,
            costtotal: 0,
            saletotal: 0,
            proforma_options: [],
            options_proforma_options: [
                { id: "startdatetime", label: "Start Datetime" },
                { id: "startcity", label: "Start City" },
                { id: "startlocation", label: "Start Location" },
                { id: "endlocation", label: "End Location" },
                { id: "endcity", label: "End City" },
                { id: "enddatetime", label: "End Datetime" },
                { id: "equipment", label: "Equipment" },
                { id: "cabin", label: "Cabin" },
                { id: "classcode", label: "Classcode" },
                { id: "classname", label: "Classname" },
            ],
            draft: {},
            item: {},
            sllines: {
                title: "Lines",
                icon: "fa fa-list text-info",
                debounce: 1500,
                busy: false,
                toolbarlibrary: [
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-line-chart mr-1 text-primary",
                        position: "toolbar",
                        action: "markup",
                        label: "Markup",
                        component: {
                            name: "",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-plus-square-o",
                        position: "toolbar",
                        action: "driver",
                        label: "Additional Driver",
                        component: {
                            name: "",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-plus-square-o",
                        position: "toolbar",
                        action: "insurance",
                        label: "Additional Insurances",
                        component: {
                            name: "",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-plus-square-o",
                        position: "toolbar",
                        action: "upgrade",
                        label: "Upgrade",
                        component: {
                            name: "",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-plus-square-o",
                        position: "toolbar",
                        action: "refueling",
                        label: "Refueling",
                        component: {
                            name: "",
                        },
                    }
                ],
                tools: [],
                // fields: [
                //     {
                //         key: "selected",
                //         label: "...",
                //     },
                //     {
                //         key: "icon",
                //         label: "",
                //         class: "text-right w-50px",
                //     },
                //     {
                //         key: "ticketno",
                //         label: "TicketNo",
                //         sortable: true,
                //     },
                //     {
                //         key: "passenger",
                //         label: "Passenger",
                //         sortable: true,
                //         class: "text-right",
                //     },
                //     {
                //         key: "route",
                //         label: "Route/Detail",
                //         sortable: true,
                //         class: "text-right",
                //         formatter: (value, key, item) => {
                //             let result = value;
                //             if (result) {
                //                 if (result.length > 30) {
                //                     result = result.slice(0, 27) + "...";
                //                 }
                //             }
                //             return result;
                //         },
                //     },
                //     {
                //         key: "datetravel",
                //         label: "DateTravel",
                //         sortable: true,
                //         formatter: (value, key, item) => {
                //             let result = "";
                //             if (value) {
                //                 result = this.$moment.unix(value * .001).utc(true).format("DD/MM/YYYY");
                //             }
                //             return result;
                //         },
                //     },
                //     {
                //         key: "qty",
                //         label: "Qty",
                //         sortable: true,
                //         class: "text-right",
                //     },
                //     {
                //         key: "lineprice",
                //         label: "Unit Price Ex VAT",
                //         sortable: true,
                //         class: "text-right",
                //         total: 0,
                //         totalled: true,
                //     },
                //     {
                //         key: "linetaxes",
                //         label: "Unit Taxes",
                //         sortable: true,
                //         class: "text-right",
                //         total: 0,
                //         totalled: true,
                //     },
                //     {
                //         key: "linesubtotal",
                //         label: "Unit Subtotal Ex VAT",
                //         sortable: true,
                //         class: "text-right",
                //         total: 0,
                //         totalled: true,
                //     },
                //     {
                //         key: "linefees",
                //         label: "Unit Fees",
                //         sortable: true,
                //         class: "text-right",
                //         total: 0,
                //         totalled: true,
                //     },
                //     {
                //         key: "linevat",
                //         label: "Unit VAT",
                //         sortable: true,
                //         class: "text-right",
                //         total: 0,
                //         totalled: true,
                //     },
                //     {
                //         key: "linetotal",
                //         label: "Unit Total",
                //         sortable: true,
                //         class: "text-right",
                //         total: 0,
                //         totalled: true,
                //     },
                //     {
                //         key: "markup",
                //         label: "Markup",
                //         sortable: true,
                //         class: "text-right",
                //         total: 0,
                //         totalled: true,
                //     },
                //     // {
                //     //     key: "tax",
                //     //     label: "Tax",
                //     //     sortable: true,
                //     //     class: "text-right",
                //     // },
                //     {
                //         key: "actions",
                //         label: "Actions",
                //         class: "actions w-110px",
                //     },

                // ],
                badges: [],
                item: {},
                items: [],
                selected: [],
            },
            state: null,
            sheets: [],
            showledgers: false,
            data: null,
            SL: [],
        };
    },
    watch: {
        tabindex: {
            immediate: true,
            async handler(newVal, oldVal) {
                if (newVal == 2) {
                    await this.sllines_renderit()
                }
            }
        },
        // markup_linesubtotal: {
        //     immediate: true,
        //     async handler(newVal, oldVal) {
        //         if (newVal) {
        //             if (parseFloat(newVal)>0) {




        //             }
        //             // let value = (parseFloat(this.sllines.item.linesubtotal) + parseFloat(newVal)) - parseFloat(this.sllines.item.blfare)
        //             // this.sllines.item.lineprice = value.toFixed(2)
        //             // console.log('set it to',value)
        //         }
        //     }
        // },
        // markup_saletotal: {
        //     async handler(newVal, oldVal) {
        //         if (newVal) {
        //         }
        //     }
        // },
        "sllines.item.qty": {
            immediate: true,
            async handler(newVal, oldVal) {
                if (parseFloat(newVal) != 0) {
                    // this.sllines.item.status = "Included"
                } else {
                    this.sllines.item.lineprice = "0"
                    this.sllines.item.linevat = ""
                    this.sllines.item.linetotal = ""
                }
                this.sumsaletotal()
            },

        },
        "sllines.item.lineprice": {
            // immediate: true,
            async handler(newVal, oldVal) {
                this.sumsaletotal()
            },
        },
        "sllines.item.linevat": {
            // immediate: true,
            async handler(newVal, oldVal) {
                this.sumsaletotal()
            },
        },
        // "sllines.item.bltotal": {
        //     // immediate: true,
        //     async handler(newVal, oldVal) {
        //         this.item.bltotal = parseFloat(this.sllines.bltotal).toFixed(2)
        //     },
        // }
    },
    computed: {
        readonly() {
            if (Object.keys(this.sllines.item).length == 0) {
                return true;
            }
            return false
        },
        posted() {
            if (this.draft.level != "success") {
                return true
            }
            if (!this.item.invoiceno) {
                return false
            }
            // if (this.reinvoice == this.item.invoiceno) {
            //     return false
            // }
            return true
        }
    },
    methods: {
        async load() {
            this.confirmno = []
            for (var i = 0; i < this.selection.length; ++i) {
                this.confirmno.push(this.selection[i].confirmno)
            }
            await this.sllines_load()
        },
        sumsaletotal() {

            this.costtotal = 0
            this.saletotal = 0
            if (this.sllines.items) {
                for (var j = 0; j < this.sllines.items.length; j++) {

                    if (parseFloat(this.sllines.items[j].qty) > 0) {

                        if (isNaN(this.sllines.items[j].lineprice)) { this.sllines.items[j].lineprice = "0" }
                        this.sllines.items[j].lineprice = parseFloat(this.sllines.items[j].lineprice).toFixed(2)
                        this.sllines.items[j].linesubtotal = (parseFloat(this.sllines.items[j].lineprice) + parseFloat(this.sllines.items[j].linetaxes) * parseFloat(this.sllines.items[j].qty)).toFixed(2);

                        if (isNaN(this.sllines.items[j].linevat)) { this.sllines.items[j].linevat = "0" }
                        this.sllines.items[j].linevat = parseFloat(this.sllines.items[j].linevat).toFixed(2)
                        this.sllines.items[j].linetotal = (parseFloat(this.sllines.items[j].linesubtotal) + parseFloat(this.sllines.items[j].linevat)).toFixed(2);

                        this.sllines.items[j].markup = (parseFloat(this.sllines.items[j].linetotal) - parseFloat(this.sllines.items[j].bltotal)).toFixed(2)

                        this.costtotal += parseFloat(this.sllines.items[j].bltotal)
                        this.saletotal += parseFloat(this.sllines.items[j].linetotal)

                    }
                }
            }
            this.markup_saletotal = this.saletotal.toFixed(2)
        },
        async sllines_load(offset, limit, page) {

            this.sllines.busy = true;
            this.sllines.items = [];

            let variables = {
                id: this.idselected,

            };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query bookings($id: String) {
                            bookings(id: $id) {
                            id
                            type
                            subject
                            details
                            blac
                            slac
                            to
                            yourref
                            eventcode
                            blinvoiceno
                            bltotal
                            sltotal
                            invoiceno
                            agent
                            proforma_layout
                            proforma_options
                            proforma {
                                id
                                line
                                bltype
                                blac
                                blfare
                                bltax
                                bltotal
                                blinvoiceno
                                ticketno
                                route
                                moreinfo
                                remark
                                passenger   
                                datetravel
                                qty
                                lineprice
                                linetaxes
                                linesubtotal
                                linefees
                                linevat
                                linetotal  
                                }             
                            }
                        }
                    `,
                    variables,
                });

                this.item = response.data.bookings[0]
                this.sllines.items = response.data.bookings[0].proforma;

                if (this.item.proforma_options) {
                    this.proforma_options = this.item.proforma_options.split(",")
                } else {
                    this.proforma_options = []
                }
                this.sumsaletotal()

                switch (this.item.type) {
                    case "XFR":
                        this.sllines.fields = [
                            {
                                key: "selected",
                                label: "...",
                            },
                            {
                                key: "icon",
                                label: "",
                                class: "text-right w-50px",
                            },
                            {
                                key: "datetravel",
                                label: "DateTravel",
                                sortable: true,
                                formatter: (value, key, item) => {
                                    let result = "";
                                    if (value) {
                                        result = this.$moment.unix(value * .001).utc(true).format("DD/MM/YYYY");
                                    }
                                    return result;
                                },
                            },
                            {
                                key: "ticketno",
                                label: "TicketNo",
                                sortable: true,
                            },

                            {
                                key: "route",
                                label: "Details",
                                sortable: true,
                                formatter: (value, key, item) => {
                                    let result = value;
                                    if (result) {
                                        if (result.length > 30) {
                                            result = result.slice(0, 27) + "...";
                                        }
                                    }
                                    return result;
                                },
                            },
                            {
                                key: "passenger",
                                label: "Passenger",
                                sortable: true,
                                class: "text-right",
                                formatter: (value, key, item) => {
                                    let result = value;
                                    if (result) {
                                        if (result.length > 30) {
                                            result = result.slice(0, 27) + "...";
                                        }
                                    }
                                    return result;
                                },
                            },

                            {
                                key: "qty",
                                label: "Qty",
                                sortable: true,
                                class: "text-right",
                            },
                            {
                                key: "lineprice",
                                label: "Unit Price Ex VAT",
                                sortable: true,
                                class: "text-right",
                                total: 0,
                                totalled: true,
                            },
                            {
                                key: "linetaxes",
                                label: "Unit Taxes",
                                sortable: true,
                                class: "text-right",
                                total: 0,
                                totalled: true,
                            },
                            {
                                key: "linesubtotal",
                                label: "Unit Subtotal Ex VAT",
                                sortable: true,
                                class: "text-right",
                                total: 0,
                                totalled: true,
                            },
                            {
                                key: "linefees",
                                label: "Unit Fees",
                                sortable: true,
                                class: "text-right",
                                total: 0,
                                totalled: true,
                            },
                            {
                                key: "linevat",
                                label: "Unit VAT",
                                sortable: true,
                                class: "text-right",
                                total: 0,
                                totalled: true,
                            },
                            {
                                key: "linetotal",
                                label: "Unit Total",
                                sortable: true,
                                class: "text-right",
                                total: 0,
                                totalled: true,
                            },
                            {
                                key: "markup",
                                label: "Markup",
                                sortable: true,
                                class: "text-right",
                                total: 0,
                                totalled: true,
                            },
                            // {
                            //     key: "tax",
                            //     label: "Tax",
                            //     sortable: true,
                            //     class: "text-right",
                            // },
                            {
                                key: "actions",
                                label: "Actions",
                                class: "actions w-110px",
                            },

                        ]
                        break;
                    default:
                        this.sllines.fields = [
                            {
                                key: "selected",
                                label: "...",
                            },
                            {
                                key: "icon",
                                label: "",
                                class: "text-right w-50px",
                            },
                            {
                                key: "datetravel",
                                label: "DateTravel",
                                sortable: true,
                                formatter: (value, key, item) => {
                                    let result = "";
                                    if (value) {
                                        result = this.$moment.unix(value * .001).utc(true).format("DD/MM/YYYY");
                                    }
                                    return result;
                                },
                            },
                            {
                                key: "ticketno",
                                label: "TicketNo",
                                sortable: true,
                            },
                            {
                                key: "passenger",
                                label: "Passenger",
                                sortable: true,
                                class: "text-right",
                            },
                            {
                                key: "route",
                                label: "Details",
                                sortable: true,
                                formatter: (value, key, item) => {
                                    let result = value;
                                    if (result) {
                                        if (result.length > 30) {
                                            result = result.slice(0, 27) + "...";
                                        }
                                    }
                                    return result;
                                },
                            },

                            {
                                key: "qty",
                                label: "Qty",
                                sortable: true,
                                class: "text-right",
                            },
                            {
                                key: "lineprice",
                                label: "Unit Price Ex VAT",
                                sortable: true,
                                class: "text-right",
                                total: 0,
                                totalled: true,
                            },
                            {
                                key: "linetaxes",
                                label: "Unit Taxes",
                                sortable: true,
                                class: "text-right",
                                total: 0,
                                totalled: true,
                            },
                            {
                                key: "linesubtotal",
                                label: "Unit Subtotal Ex VAT",
                                sortable: true,
                                class: "text-right",
                                total: 0,
                                totalled: true,
                            },
                            {
                                key: "linefees",
                                label: "Unit Fees",
                                sortable: true,
                                class: "text-right",
                                total: 0,
                                totalled: true,
                            },
                            {
                                key: "linevat",
                                label: "Unit VAT",
                                sortable: true,
                                class: "text-right",
                                total: 0,
                                totalled: true,
                            },
                            {
                                key: "linetotal",
                                label: "Unit Total",
                                sortable: true,
                                class: "text-right",
                                total: 0,
                                totalled: true,
                            },
                            {
                                key: "markup",
                                label: "Markup",
                                sortable: true,
                                class: "text-right",
                                total: 0,
                                totalled: true,
                            },
                            // {
                            //     key: "tax",
                            //     label: "Tax",
                            //     sortable: true,
                            //     class: "text-right",
                            // },
                            {
                                key: "actions",
                                label: "Actions",
                                class: "actions w-110px",
                            },

                        ]
                }

                switch (this.item.type) {
                    case "CAR":
                        this.sllines.tools = "go,export,reset,edit,deleteconfirm,driver,insurance,upgrade,refueling,up,down,markup"
                        break;
                    default:
                        this.sllines.tools = "go,export,reset,edit,deleteconfirm,up,down,markup"
                }

            } catch (error) {
                console.log(error);
            }

            this.sllines.busy = false;
        },
        async sllines_click(a, ss) {
            console.log("sllines_click", a, ss);

            let state = this.sllines;
            let found = null
            let route = null
            let paste = {
                id: "__copy", moreinfo: "", lineprice: "0", linevat: "0", linetotal: "0", blfare: "0", bltax: "0", bltotal: "0"
            }
            switch (a) {

                case "go":
                    await this.sllines_load();
                    break;

                case "reset":
                    await this.sllines_resetit()
                    break;

                case "selectall":
                    // for (var j = 0; j < ss.length; j++) {
                    //     this.markup_lineprice = (parseFloat(ss[j].lineprice) - parseFloat(ss[j].blfare)).toFixed(2)
                    //     this.markup_linesubtotal = (parseFloat(ss[j].lineprice) + parseFloat(ss[j].linetaxes)).toFixed(2)
                    // }
                    break;

                case "clone":
                    if (state.item) {
                        this.sllines.items.push({ ...state.item, id: "__copy", line: (this.sllines.items.length + 1).toString(), route: "", moreinfo: "", lineprice: "0", linevat: "0", linetotal: "0", blfare: "0", bltax: "0", bltotal: "0" })
                    }
                    break;

                case "driver":
                    route = 'Additional Driver'
                    found = this.sllines.items.find(o => o.route == route)
                    if (!found) {
                        this.sllines.items.push({ ...state.items[0], ...paste, route, line: (this.sllines.items.length + 1).toString() })
                    }
                    break;

                case "insurance":
                    route = 'Additional Insurances'
                    found = this.sllines.items.find(o => o.route == route)
                    if (!found) {
                        this.sllines.items.push({ ...state.items[0], ...paste, route, line: (this.sllines.items.length + 1).toString() })
                    }
                    break;

                case "upgrade":
                    route = 'Upgrade'
                    found = this.sllines.items.find(o => o.route == route)
                    if (!found) {
                        this.sllines.items.push({ ...state.items[0], ...paste, route, line: (this.sllines.items.length + 1).toString() })
                    }
                    break;

                case "refueling":
                    route = 'Refueling'
                    found = this.sllines.items.find(o => o.route == route)
                    if (!found) {
                        this.sllines.items.push({ ...state.items[0], ...paste, route, line: (this.sllines.items.length + 1).toString() })
                    }
                    break;

                case "delete":
                    route = ss[0].route
                    found = this.sllines.items.findIndex(o => o.route == route)
                    if (found != 0) {
                        this.sllines.items.splice(found, 1)
                    }
                    break;

                case "up":
                    route = ss[0].route
                    found = this.sllines.items.findIndex(o => o.route == route)
                    if (found != 0) {
                        let target = found - 1
                        if (target != 0) {
                            console.log('move up', found, target, this.sllines.items.length)
                            moveItem(this.sllines.items, found, target)
                        }
                    }
                    break;

                case "down":
                    route = ss[0].route
                    found = this.sllines.items.findIndex(o => o.route == route)
                    if (found != 0) {
                        console.log('move down', found)
                        let target = found + 1
                        if (target != 0) {
                            console.log('move up', found, target, this.sllines.items.length)
                            moveItem(this.sllines.items, found, target)
                        }
                    }
                    break;

                case "markup_lineprice":
                    for (var j = 0; j < this.sllines.selected.length; j++) {
                        this.sllines.selected[j].lineprice = (parseFloat(this.sllines.selected[j].blfare) + parseFloat(this.markup_lineprice)).toFixed(2)
                    }
                    break;

                case "markup_linesubtotal":
                    for (var j = 0; j < this.sllines.selected.length; j++) {
                        this.sllines.selected[j].lineprice = (parseFloat(this.sllines.selected[j].blfare) + (parseFloat(this.markup_linesubtotal) - parseFloat(this.sllines.selected[j].bltotal))).toFixed(2)
                    }
                    break;

                case "markup_saletotal":
                    let markup_total = parseFloat(this.markup_saletotal) - parseFloat(this.costtotal)
                    let markup_line = (markup_total / this.sllines.items.length).toFixed(2)
                    let markup_remainder = (markup_total - (markup_line * this.sllines.items.length)).toFixed(2)

                    console.log('set the markup total to', this.markup_saletotal, this.costtotal, markup_total, markup_line, markup_remainder)
                    for (var j = 0; j < this.sllines.items.length; j++) {
                        if (j < this.sllines.items.length - 1) {
                            this.sllines.items[j].lineprice = (parseFloat(this.sllines.items[j].blfare) + parseFloat(markup_line)).toFixed(2)
                        } else {
                            this.sllines.items[j].lineprice = (parseFloat(this.sllines.items[j].blfare) + parseFloat(markup_line) + parseFloat(markup_remainder)).toFixed(2)
                        }
                    }
                    this.sumsaletotal()
                    break;

                case "edit":
                    this.edit = !this.edit
                    break;


                case "save":
                    await this.sllines_saveit()
                    break;

            }
        },
        async sllines_select(ss, tools) {
            // return
            console.log("sllines_select", ss);

            let state = this.sllines;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "go", "filter", "add", "export", "reset", "driver", "insurance", "upgrade", "refueling"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "notes"]
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                //"save", "deleteconfirm",
                enabled = ["deleteconfirm", "markup"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }

            if (state.selected.length > 0) {
                state.item = state.selected[0]  // WHAT YOU SELECTED

                this.datetravel = this.$moment.unix(state.item.datetravel * 0.001).utc(true).format("YYYY-MM-DD")

                this.markup_lineprice = (parseFloat(state.item.lineprice) - parseFloat(state.item.blfare)).toFixed(2)
                this.markup_linesubtotal = (parseFloat(state.item.lineprice) + parseFloat(state.item.linetaxes)).toFixed(2)

            } else {
                state.item = {}
            }

            this.message = ""
        },
        async sllines_resetit() {
            console.log('sllines_resetit')

            this.message = ""
            this.sllines.busy = true;

            let variables = {
                selected: [{
                    id: this.item.id,
                }],
                data: "proforma",
                apply: true
            }
            console.log(variables)

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation bookings_reset($selected: [Booking_input], $data: String, $apply: Boolean) {
                            bookings_reset(selected: $selected, data: $data, apply: $apply ) {
                                id
                            }
                        }
                        `,
                    variables,
                });

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
                console.log(error)

            }
            this.sllines.busy = false;
            await this.sllines_load()

        },
        async sllines_saveit() {
            console.log('sllines_saveit')

            this.message = ""

            this.sllines.busy = true;

            let proforma = [...this.sllines.items]
            proforma.forEach(function (v) { delete v.markup });

            let variables = {
                rows: [{
                    id: this.item.id,
                    bltotal: this.item.bltotal,
                    blinvoiceno: this.item.blinvoiceno,
                    proforma_options: this.proforma_options.length >0? this.proforma_options.join(","): "",
                    proforma
                }]
            }

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation bookings_save($rows: [Booking_input]) {
                            bookings_save(rows: $rows) {
                                id
                                proforma {
                                    id
                                }
                            }
                        }
                        `,
                    variables,
                });
                this.message = "<span class='text-primary'>Saved it.</span>";
                this.sumsaletotal()

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }
            this.sllines.busy = false;

        },
        async sllines_renderit() {

            console.log('sllines_renderit')
            this.busy = true;

            let variables = {
                selected: [{ id: this.idselected }]
                // emailto: emailto ? this.emailto : null,
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                    query bookings_draftinvoice(
                        $selected: [Booking_input]
                        $emailto: String
                    ) {
                        bookings_draftinvoice(
                            selected: $selected
                            emailto: $emailto
                        ) {
                        ref
                        to
                        address
                        dateref
                        slac
                        agent
                        yourref
                        eventname
                        vatregion
                        saletotal
                        terms
                        credit
                        id
                        data
                        document {
                            fields {
                                key
                                label
                                class
                            }
                            items
                        }
                        documentpdf
                        message
                        level
                        }
                    }
                    `,
                    variables,
                    fetchPolicy: "no-cache",
                });

                this.draft = response.data.bookings_draftinvoice[0];
                this.data = JSON.parse(this.draft.data);
                this.SL = []
                this.SL.push({ ...this.data.SL[0] });
                delete this.SL[0].items;

            } catch (error) {
                console.log(error);
            }

            this.busy = false;

        },
        async sllines_postit() {

            console.log('sllines_postit')

            await this.sllines_saveit()

            this.busy = true;

            let variables = {
                selected: [{ id: this.idselected }],
                apply: true
                // emailto: emailto ? this.emailto : null,
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                    query bookings_draftinvoice(
                        $selected: [Booking_input]
                        $apply: Boolean
                        $emailto: String
                    ) {
                        bookings_draftinvoice(
                            selected: $selected
                            apply: $apply
                            emailto: $emailto
                        ) {
                        ref
                        to
                        address
                        dateref
                        slac
                        agent
                        yourref
                        eventname
                        vatregion
                        saletotal
                        terms
                        credit
                        id
                        data
                        document {
                            fields {
                            key
                            label
                            class
                            }
                            items
                        }
                        message
                        level
                        }
                    }
                    `,
                    variables,
                    fetchPolicy: "no-cache",
                });

                this.draft = response.data.bookings_draftinvoice[0];

            } catch (error) {
                console.log(error);
            }

            await this.sllines_load()

            this.busy = false;
        },

        sllines_markup(v) {
            console.log(v)
            switch (v) {
                case "lineprice":
                    this.sllines.item.lineprice = (parseFloat(this.sllines.item.lineprice) + parseFloat(this.markup_lineprice)).toFixed(2)
                    break;
                case "linesubtotal":
                    this.sllines.item.lineprice = (parseFloat(this.sllines.item.lineprice) + parseFloat(this.markup_linesubtotal) - parseFloat(this.sllines.item.linesubtotal)).toFixed(2)
                    break;

            }
        }
    },
};
</script>
  
  
  